import { Description, HeaderDash,  } from "../../../common"
import { Action } from "./domain/actions";

export interface ActionsHeaderProps {
    workout: string;
    actions: Action[];
    isLoading: boolean;
}

export const ActionsHeader = ({ workout, actions, isLoading }: ActionsHeaderProps) => {
    return (
        <>
            <HeaderDash title="Ações"
                description={workout}
            />
            {!isLoading && !actions.length && (
                <Description align="center" margintop="120px">
                    Nenhuma ação encontrada, cadastre uma ação para começar o drill.
                </Description>
            )}
        </>
    )
}

